import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    layout: {
      navPos: 'left', // top, bottom, left, right, false
      toolbar: 'top', // top, bottom, false
      footer: true, // above, below, false
      boxed: false, // true, false
      roundedCorners: false, // true, false
      viewAnimation: 'fade-top' // fade-left, fade-right, fade-top, fade-top-in-out, fade-bottom, fade-bottom-in-out, fade, false
    },
    valueAccountNumber: '',
    AccountNumbers: [],
    splashScreen: true,
    logged: true,
    accountTypeObj: '',
    transferAccountInfos: [],
    selectLang: '',
    logoutDialog: false,
    source: '',
    accountInfo: {},
    clientProfile: {}
  },

  mutations: {
    setAccountNumbers (state, arr) {
      state.AccountNumbers = arr
    },
    setValueAccountNumber (state, accountNumber) {
      state.valueAccountNumber = accountNumber
    },
    setLayout (state, payload) {
      if (payload && payload.navPos !== undefined) {
        state.layout.navPos = payload.navPos
      }
      if (payload && payload.toolbar !== undefined) {
        state.layout.toolbar = payload.toolbar
      }
      if (payload && payload.footer !== undefined) {
        state.layout.footer = payload.footer
      }
      if (payload && payload.boxed !== undefined) {
        state.layout.boxed = payload.boxed
      }
      if (payload && payload.roundedCorners !== undefined) {
        state.layout.roundedCorners = payload.roundedCorners
      }
      if (payload && payload.viewAnimation !== undefined) {
        state.layout.viewAnimation = payload.viewAnimation
      }
    },
    setLogin (state, payload) {
      state.logged = true
    },
    setLogout (state, payload) {
      state.layout.navPos = null
      state.layout.toolbar = null
      state.logged = false
    },
    setSplashScreen (state, payload) {
      state.splashScreen = payload
    },
    setUser (state, val) {
      state.user = val
      window.localStorage.setItem('user', JSON.stringify(state.user))
    },
    setAccountTypeObj (state, val) {
      state.accountTypeObj = val
    },
    setTransferAccountInfos (state, val) {
      state.transferAccountInfos = val
    },
    setCurLang (state, val) {
      state.selectLang = val
    },
    setLogoutDialog (state, val) {
      state.logoutDialog = val
    },
    setToolbar (state, val) {
      state.layout.toolbar = val
    },
    setSource (state, val) {
      state.source = val
    },
    setAccountInfo (state, val) {
      state.accountInfo = val
    },
    setAllAccountInfo (state, val) {
      state.allAccountInfo = val
    },
    setClientProfile (state, val) {
      state.clientProfile = val
    }
  },
  actions: {},
  getters: {
    layout (state, getters) {
      return state.layout
    },
    navPos (state, getters) {
      return state.layout.navPos
    },
    toolbar (state, getters) {
      return state.layout.toolbar
    },
    footer (state, getters) {
      return state.layout.footer
    },
    accountNumbers (state, getters) {
      return state.AccountNumbers
    },
    valueAccountNumber (state, getters) {
      return state.valueAccountNumber
    },
    boxed (state, getters) {
      return state.layout.boxed
    },
    roundedCorners (state, getters) {
      return state.layout.roundedCorners
    },
    viewAnimation (state, getters) {
      return state.layout.viewAnimation
    },
    isLogged (state, getters) {
      return state.logged
    },
    splashScreen (state, getters) {
      return state.splashScreen
    },
    getUser (state, getters) {
      return state.user
    },
    getAccountTypeObj (state, getters) {
      return state.accountTypeObj
    },
    getTransferAccountInfos (state, getter) {
      return state.transferAccountInfos
    },
    selectLang (state, getters) {
      return state.selectLang
    },
    getLogoutDialog (state, getters) {
      return state.logoutDialog
    },
    getSource (state, getters) {
      return state.source
    },
    getAccountInfo (state, getters) {
      return state.accountInfo
    },
    getClientProfile (state, getters) {
      return state.clientProfile
    }
  },
  plugins: [createPersistedState({ paths: ['layout'] })],
  strict: debug
})
